import { getFetch, postFetch, putFetch, deleteFetch } from '../utils/fetch';
import { FACILITY_AUDIT_API } from './config';

export function getList(query) {
  return getFetch(`${FACILITY_AUDIT_API()}`, query);
}

export function getOne(_id) {
  return getFetch(`${FACILITY_AUDIT_API()}/${_id}`);
}

export function updateOne(_id, data = {}) {
  return putFetch(`${FACILITY_AUDIT_API()}/${_id}`, data);
}

export function deleteOne(_id) {
  return deleteFetch(`${FACILITY_AUDIT_API()}/${_id}`);
}

export function create(obj) {
  return postFetch(`${FACILITY_AUDIT_API()}`, obj);
}

export function getSearchList(query) {
  return getFetch(`${FACILITY_AUDIT_API()}`, {
    search: query,
    field: ['FacilityNameFull'],
    page: 1,
    itemPerPage: 10,
  });
}

export function getAll() {
  return getFetch(`${FACILITY_AUDIT_API()}/getAll`);
}

export function exportData(query) {
  return getFetch(`${FACILITY_AUDIT_API()}/export`, {
    ...query,
  });
}

export function exportDataWithIds(query) {
  return postFetch(`${FACILITY_AUDIT_API()}/exportWithQuery`, {
    ...query,
  });
}

// DETAIL

export function getAuditDetail(_id) {
  return getFetch(`${FACILITY_AUDIT_API()}/${_id}/detail`);
}

export function getOneAuditDetail(_id) {
  return getFetch(`${FACILITY_AUDIT_API()}/detail-child/${_id}`);
}

export function updateOneAuditDetail(_id, data = {}) {
  return putFetch(`${FACILITY_AUDIT_API()}/detail-child/${_id}`, data);
}




// WEBPACK FOOTER //
// ./src/api/facilityAuditApi.js